module.exports = __webpack_public_path__ + "img/20210906-1630898460150560.7fc7ab09.jpg";